import styled from '@emotion/styled';

import { isEmpty } from 'lodash';

import COLOR from '../../../../shared/constant/colorset';

import { amplitudeService } from '../../../../shared/amplitude';
import { SelectCategoryBanner, SelectCategoryMenu } from '../../../../shared/amplitude/events';

import ListContainer from './ListContainer';
import Menu from '../components/Menu';
import Banner from '../components/Banner';
import { LoadingList } from '../components/LoadingList';

import { useAppSelector } from '../../../../shared/store';

const Container = styled.div`
  width: 1050px;
  margin: 0 auto;
  padding-top: 26px;
`;

const PageTitle = styled.h3`
  padding: 23px 0 20px;
  font-weight: 500;
  font-size: 28px;
  color: ${COLOR.kurlyGray800};
  line-height: 35px;
  letter-spacing: -1px;
  text-align: center;
`;

interface Props {
  onSubMenuChange(code: string, section: string): void;
}

export default function ProductListContainer({ onSubMenuChange }: Props) {
  const {
    listHeader,
    paramCode,
    section,
    isLoading,
  } = useAppSelector(({ productList }) => productList);
  const { title, banner, siblingCategorys } = listHeader;

  const handleClickBanner = (url: string) => {
    amplitudeService.logEvent(new SelectCategoryBanner({ listHeader, paramCode, url }));
  };

  const handleMenuChange = (code: string) => {
    onSubMenuChange(code, section);
    amplitudeService.logEvent(new SelectCategoryMenu({ listHeader, code }));
  };

  if (isLoading) {
    return (
      <Container>
        <LoadingList />
      </Container>
    );
  }

  return (
    <Container id="container">
      {!isEmpty(banner) &&
        <Banner
          banner={banner}
          onClickBanner={handleClickBanner}
        />
      }
      {section !== 'search' && <PageTitle>{title}</PageTitle>}
      {!isEmpty(siblingCategorys) &&
        <Menu
          code={paramCode}
          siblingCategorys={siblingCategorys}
          onMenuChange={handleMenuChange}
        />
      }
      <ListContainer />
    </Container>
  );
}
